import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    toastr.options = {
      closeButton: true,
      debug: false,
      newestOnTop: true,
      progressBar: false,
      positionClass: "toast-top-right",
      preventDuplicates: false,
      onclick: null,
      showDuration: "300",
      hideDuration: "1000",
      timeOut: "5000",
      extendedTimeOut: "1000",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "slideDown",
      hideMethod: "slideUp",
    }

    const types = ["success", "error", "notice", "alert"]
    types.forEach(type => {
      const messageEl = document.getElementById(`flash_${type}_message`)
      const titleEl   = document.getElementById(`flash_${type}_title`)
      if (messageEl) {
        const message = messageEl.textContent.trim()
        const title   = titleEl ? titleEl.textContent.trim() : ""
        if (type === "success" || type === "notice") {
          toastr.success(message, title)
        } else {
          toastr.error(message, title)
        }
      }
    })
  }
}